import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import TestPage from './pages/TestPage';
import EmployeeProductonTable from './pages/ProductionTable'
import LoginPage from './pages/LoginPage';
import ProductPage from './pages/ProductsPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import EmployeePage from './pages/EmployeePage';

function App() {
 return (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/employee-production-page" element={<EmployeeProductonTable />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/employees" element={<EmployeePage />} />
            <Route path="*" element={<NotFoundPage />} /> {/* Catch-all route */}
          </Routes>
        </BrowserRouter>
      );
}

export default App;
